import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { enrichMessageCollection } from 'Components/ComponentLibrary/Organisms/MessageList/Utils';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import moment from 'moment';
import MessageListItem from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem';
import { DataValueMap } from 'Helpers/Testing';
import { noop } from 'Helpers/PropTypes';
import ContextMenuProvider from 'Components/UI/ContextMenu/ContextMenuProvider';
import { FDBox } from '@facet-wealth/design';
import NewMessageIndicator from './NewMessageIndicator';
import MessageDate from './MessageDate';

const useStyles = buildUseStyles('MessageList', ((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
  },
})));

const MessageList = ({
  messageResources,
  enableMessageEditing,
  onMessageLoadComplete,
  scrollRef,
}) => {
  const classes = useStyles();
  const [messagesLoadedCount, setMessagesLoadedCount] = React.useState(0);
  const totalMessages = messageResources.length;
  const allMessagesLoaded = totalMessages === messagesLoadedCount;
  const enrichedMessages = enrichMessageCollection(messageResources);

  React.useEffect(() => {
    onMessageLoadComplete();
  }, [allMessagesLoaded]);

  const onMessageLoaded = () => {
    setMessagesLoadedCount(messagesLoaded => messagesLoaded + 1);
  };

  return (
    <ContextMenuProvider>
      <Paper
        className={classes.root}
      >
        {enrichedMessages.map(({ enrichedData, messageResource }, i) => {
          const isDraft = messageResource.isTruthy('isDraft');
          const messageMoment = (isDraft) ? moment() : moment(messageResource.attr('publishedDate'));
          const lastMessage = enrichedMessages[i + 1] === undefined;

          return (
            <FDBox
              ref={scrollRef}
              key={messageResource.id()}
            >
              {enrichedData.isNewDay ? <MessageDate date={messageMoment} /> : null}
              {enrichedData.isFirstNew ? <NewMessageIndicator /> : null}
              <MessageListItem
                scrollRef={lastMessage ? scrollRef : undefined}
                messageResource={messageResource}
                enableMessageEditing={enableMessageEditing}
                onLoadComplete={() => onMessageLoaded()}
                dataTestAttributes={
                    DataValueMap
                      .init('message-list-item')
                      .append(DataValueMap.keyMap.dataResourceId, messageResource.id())
                      .append(DataValueMap.keyMap.dataIndex, i.toString())
                      .build()
                  }
              />
            </FDBox>
          );
        })}
      </Paper>
    </ContextMenuProvider>
  );
};

MessageList.defaultProps = {
  enableMessageEditing: false,
  onMessageLoadComplete: noop,
  scrollRef: null,
};

MessageList.propTypes = {
  messageResources: PropTypes.array.isRequired,
  enableMessageEditing: PropTypes.bool,
  onMessageLoadComplete: PropTypes.func,
  scrollRef: PropTypes.object,
};

export default MessageList;
